// ─── Navbar ───────────────────────────────────────────────
export const nav_home = "主頁";
export const nav_accounting = "會計服務";
export const nav_taxation = "稅務服務";
export const nav_mpf = "強積金服務";
export const nav_about = "關於我們";
export const nav_contact = "聯絡我們";
export const nav_cta = "免費諮詢";

// ─── Hero ─────────────────────────────────────────────────
export const hero_tag = "香港值得信賴的財務夥伴";
export const hero_h1_1 = "專業會計";
export const hero_h1_2 = "為您的業務";
export const hero_h1_3 = "保駕護航";
export const hero_desc = "Nice Accounting 為香港各類企業及個人提供全面的會計、稅務及強積金服務。讓我們處理數字，您專注發展業務。";
export const hero_cta1 = "預約諮詢";
export const hero_cta2 = "了解我們的服務";
export const hero_scroll = "向下滾動";
export const hero_stat1_label = "年業務經驗";
export const hero_stat2_label = "滿意客戶";
export const hero_stat3_label = "客戶留存率";
export const hero_stat4_label = "已申報稅務";

// ─── About Us ─────────────────────────────────────────────
export const about_tag = "我們的故事";
export const about_heading = "關於 Nice Accounting";
export const about_p1 = "Nice Accounting 的創立宗旨是：讓香港每一家企業——無論是初創公司還是成熟企業——都能獲得專業、可負擔且可靠的財務服務。";
export const about_p2 = "多年來，我們在業界建立了以精準、主動及誠信著稱的聲譽，並真心致力於客戶的財務健康。我們的持牌專業團隊在會計、稅務及強積金管理方面擁有數十年豐富經驗。";
export const about_p3 = "我們相信，卓越的會計服務不只是合規——它更是企業的策略優勢。因此，我們超越數字，提供洞見，助您做出更明智的商業決策。";
export const about_values_heading = "我們的核心價值";
export const about_values_sub = "指導我們一切行動的原則。";
export const about_val1_title = "專業卓越";
export const about_val1_desc = "我們的團隊由持牌會計師組成，在會計、稅務及強積金各領域均具備深厚專業知識。";
export const about_val2_title = "以客為本";
export const about_val2_desc = "我們視每段客戶關係為長期合作夥伴關係，並根據您的獨特需求量身定制服務。";
export const about_val3_title = "保密與信任";
export const about_val3_desc = "您的財務資料由我們以最高的謹慎態度處理，並受到嚴格的保密規程保護。";
export const about_val4_title = "主動諮詢";
export const about_val4_desc = "我們不僅計算數字，更積極識別改善您財務狀況的機會。";

// ─── Accounting Services ───────────────────────────────────
export const acct_tag = "我們的服務";
export const acct_heading = "會計服務";
export const acct_desc = "從日常簿記到完整財務報告，我們經驗豐富的團隊確保您的賬目隨時井然有序。";
export const acct_s1_title = "簿記及賬目";
export const acct_s1_desc = "準確及時的簿記，確保您的財務記錄清晰、有序，隨時準備接受審計。";
export const acct_s1_i1 = "每月／每季簿記";
export const acct_s1_i2 = "銀行對賬";
export const acct_s1_i3 = "應付及應收賬款";
export const acct_s1_i4 = "財務報表編製";
export const acct_s2_title = "財務報告";
export const acct_s2_desc = "清晰全面的財務報告，讓您真實了解業務表現。";
export const acct_s2_i1 = "損益表";
export const acct_s2_i2 = "資產負債表編製";
export const acct_s2_i3 = "現金流量表";
export const acct_s2_i4 = "管理賬目";
export const acct_s3_title = "審計支援";
export const acct_s3_desc = "在整個審計過程中提供專業協助，確保合規及準確。";
export const acct_s3_i1 = "審計文件準備";
export const acct_s3_i2 = "與核數師協調";
export const acct_s3_i3 = "法定審計支援";
export const acct_s3_i4 = "內部審計檢視";
export const acct_s4_title = "公司秘書";
export const acct_s4_desc = "提供全面的公司秘書服務，確保您的業務符合香港法規。";
export const acct_s4_i1 = "周年申報表呈報";
export const acct_s4_i2 = "法定記錄維護";
export const acct_s4_i3 = "董事會決議";
export const acct_s4_i4 = "更換董事／股東";

// ─── Taxation Services ────────────────────────────────────
export const tax_tag = "管理您的稅務責任";
export const tax_heading = "稅務服務";
export const tax_desc = "自信應對香港稅務制度。我們處理您稅務事宜的每個環節——從申報、規劃到爭議解決，一應俱全。";
export const tax_s1_title = "利得稅";
export const tax_s1_desc = "準確編製並及時提交企業利得稅報稅表，以盡量減少稅款及避免罰款。";
export const tax_s2_title = "薪俸稅";
export const tax_s2_desc = "為個人、僱員及董事提供個人入息稅申報服務，確保符合稅務局規定。";
export const tax_s3_title = "物業稅";
export const tax_s3_desc = "專業處理香港業主及物業持有人的物業稅事宜。";
export const tax_s4_title = "稅務規劃及諮詢";
export const tax_s4_desc = "提供策略性稅務規劃建議，合法降低您的稅務負擔，改善現金流。";
export const tax_s5_title = "轉讓定價";
export const tax_s5_desc = "為跨國企業提供全面的轉讓定價文件及合規服務。";
export const tax_s6_title = "稅務局查詢及反對";
export const tax_s6_desc = "專業代表及協助處理稅務局的查詢、反對及上訴事宜。";
export const tax_cta_heading = "不確定您的稅務責任？";
export const tax_cta_sub = "即可獲得我們持牌專業人士提供的免費30分鐘稅務審查。";
export const tax_cta_btn = "預約免費稅務審查";

// ─── MPF Services ─────────────────────────────────────────
export const mpf_tag = "強制性公積金";
export const mpf_heading = "強積金服務";
export const mpf_desc = "確保您的企業高效準確地履行所有強制性公積金責任。我們消除強積金管理的繁複性，讓您專注於業務運營。";
export const mpf_step1_title = "強積金計劃設立";
export const mpf_step1_desc = "我們協助僱主為員工登記並設立合適的強積金計劃，確保從第一天起完全符合規定。";
export const mpf_step2_title = "供款管理";
export const mpf_step2_desc = "及時準確地計算及安排僱主和僱員的強制性及自願性供款。";
export const mpf_step3_title = "僱員登記";
export const mpf_step3_desc = "處理新員工登記的所有文件及程序，並管理僱傭狀況的變更。";
export const mpf_step4_title = "離職及對沖";
export const mpf_step4_desc = "在合約終止、退休時，就處理強積金權益及運用對沖機制（如適用）提供專業指導。";
export const mpf_h1 = "全面持牌及合規監管";
export const mpf_h2 = "及時提交供款";
export const mpf_h3 = "支援各規模企業";
export const mpf_h4 = "指定強積金顧問跟進";
export const mpf_cta = "查詢強積金服務";

// ─── Contact ──────────────────────────────────────────────
export const contact_tag = "聯絡我們";
export const contact_heading = "聯絡我們";
export const contact_desc = "有任何疑問或準備好開始了？聯絡我們的團隊，我們將於一個工作日內回覆您。";
export const contact_d1_label = "辦公室地址";
export const contact_d1_value = "香港新蒲崗";
export const contact_d2_label = "電話";
export const contact_d2_value = "+852 5680 3868";
export const contact_d3_label = "電郵";
export const contact_d3_value = "hello@niceaccountinghk.com";
export const contact_d4_label = "辦公時間";
export const contact_d4_value = "週一至週五：上午10時 – 下午5時";
export const contact_f_name = "全名 *";
export const contact_f_name_ph = "例如：陳大文";
export const contact_f_email = "電郵地址 *";
export const contact_f_email_ph = "例如：chan@company.com";
export const contact_f_phone = "電話號碼";
export const contact_f_phone_ph = "例如：+852 9123 4567";
export const contact_f_service = "感興趣的服務";
export const contact_f_service_ph = "選擇服務";
export const contact_f_company = "公司名稱";
export const contact_f_company_ph = "例如：ABC有限公司";
export const contact_f_msg = "您的留言 *";
export const contact_f_msg_ph = "請告訴我們您的需求...";
export const contact_f_submit = "發送查詢";
export const contact_f_sending = "發送中...";
export const contact_f_privacy = "您的資料將受到嚴格保密。";
export const contact_success_title = "訊息已發送！";
export const contact_success_desc = "感謝您的來信。我們的團隊將於一個工作日內與您聯繫。";
export const contact_success_again = "再次發送訊息";
export const contact_error = "出現錯誤，請稍後重試或直接發送電郵給我們。";
export const contact_svc1 = "會計服務";
export const contact_svc2 = "稅務服務";
export const contact_svc3 = "強積金服務";
export const contact_svc4 = "商業諮詢";
export const contact_svc5 = "一般查詢";

// ─── Footer ───────────────────────────────────────────────
export const footer_desc = "您在香港值得信賴的會計夥伴。專業、可靠，致力於您的財務成功。";
export const footer_phone = "+852 5680 3868";
export const footer_sec1 = "服務";
export const footer_sec2 = "公司";
export const footer_l1_1 = "會計服務";
export const footer_l1_2 = "稅務服務";
export const footer_l1_3 = "強積金服務";
export const footer_l1_4 = "商業諮詢";
export const footer_l2_1 = "關於我們";
export const footer_l2_2 = "我們的團隊";
export const footer_l2_3 = "我們的價值觀";
export const footer_l2_4 = "聯絡我們";
export const footer_copy = "Nice Accounting。版權所有。";
export const footer_privacy = "私隱政策";
export const footer_terms = "服務條款";

const common = {
  nav_home, nav_accounting, nav_taxation, nav_mpf, nav_about, nav_contact, nav_cta,
  hero_tag, hero_h1_1, hero_h1_2, hero_h1_3, hero_desc, hero_cta1, hero_cta2, hero_scroll,
  hero_stat1_label, hero_stat2_label, hero_stat3_label, hero_stat4_label,
  about_tag, about_heading, about_p1, about_p2, about_p3, about_values_heading, about_values_sub,
  about_val1_title, about_val1_desc, about_val2_title, about_val2_desc,
  about_val3_title, about_val3_desc, about_val4_title, about_val4_desc,
  acct_tag, acct_heading, acct_desc,
  acct_s1_title, acct_s1_desc, acct_s1_i1, acct_s1_i2, acct_s1_i3, acct_s1_i4,
  acct_s2_title, acct_s2_desc, acct_s2_i1, acct_s2_i2, acct_s2_i3, acct_s2_i4,
  acct_s3_title, acct_s3_desc, acct_s3_i1, acct_s3_i2, acct_s3_i3, acct_s3_i4,
  acct_s4_title, acct_s4_desc, acct_s4_i1, acct_s4_i2, acct_s4_i3, acct_s4_i4,
  tax_tag, tax_heading, tax_desc,
  tax_s1_title, tax_s1_desc, tax_s2_title, tax_s2_desc, tax_s3_title, tax_s3_desc,
  tax_s4_title, tax_s4_desc, tax_s5_title, tax_s5_desc, tax_s6_title, tax_s6_desc,
  tax_cta_heading, tax_cta_sub, tax_cta_btn,
  mpf_tag, mpf_heading, mpf_desc,
  mpf_step1_title, mpf_step1_desc, mpf_step2_title, mpf_step2_desc,
  mpf_step3_title, mpf_step3_desc, mpf_step4_title, mpf_step4_desc,
  mpf_h1, mpf_h2, mpf_h3, mpf_h4, mpf_cta,
  contact_tag, contact_heading, contact_desc,
  contact_d1_label, contact_d1_value, contact_d2_label, contact_d2_value,
  contact_d3_label, contact_d3_value, contact_d4_label, contact_d4_value,
  contact_f_name, contact_f_name_ph, contact_f_email, contact_f_email_ph,
  contact_f_phone, contact_f_phone_ph, contact_f_service, contact_f_service_ph,
  contact_f_company, contact_f_company_ph, contact_f_msg, contact_f_msg_ph,
  contact_f_submit, contact_f_sending, contact_f_privacy,
  contact_success_title, contact_success_desc, contact_success_again, contact_error,
  contact_svc1, contact_svc2, contact_svc3, contact_svc4, contact_svc5,
  footer_desc, footer_phone, footer_sec1, footer_sec2,
  footer_l1_1, footer_l1_2, footer_l1_3, footer_l1_4,
  footer_l2_1, footer_l2_2, footer_l2_3, footer_l2_4,
  footer_copy, footer_privacy, footer_terms,
};

export default common;
